import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the redirect back from Google OAuth via Supabase.
 * Supabase writes the session to localStorage automatically when
 * the URL contains the auth tokens — we just need to redirect.
 */
function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    // Give Supabase a moment to process the URL hash / query params
    const timer = setTimeout(async () => {
      try {
        const { createClient } = await import('@supabase/supabase-js');
        const supabase = createClient(
          process.env.REACT_APP_SUPABASE_URL,
          process.env.REACT_APP_SUPABASE_ANON_KEY,
        );
        const { data: { session } } = await supabase.auth.getSession();
        navigate(session ? '/' : '/login');
      } catch {
        navigate('/login');
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Signing in…</p>
    </div>
  );
}

export default AuthCallback;
